import React, {Component} from 'react'
import PropTypes from "prop-types";
import Error from "../single_components/Error";
import Select from "react-select";
import {authenticationService} from "../../services/AuthenticationService";

class ImagingBlock extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
        }
    }
    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    render() {
        let {t} = this.props

        let {entry}= this.state

        return (
            <div className={'patientsFormBoxes-referral'}>
                    <div className={'inputSlotsDoc-full'}>
                        <label/>
                        <textarea  className={'info-inputBoxStyle boxMargin'} defaultValue={entry.ImagingAndHelpfulTests} maxLength={"5000"}
                                   onChange={(event) => this.props.onValueChange("ImagingAndHelpfulTests", event.target.value)}/>
                    </div>
            </div>

        )
    }
}

ImagingBlock.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default ImagingBlock;
